import { render } from "./Athletism.vue?vue&type=template&id=13e6ac39&scoped=true"
import script from "./Athletism.vue?vue&type=script&lang=js"
export * from "./Athletism.vue?vue&type=script&lang=js"

import "./Athletism.vue?vue&type=style&index=0&id=13e6ac39&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e6ac39"]])

export default __exports__